import {
  DERIVED_STATE_KEYS,
  type FieldDerivedStateKey,
  type IFieldDerivedState,
} from './IFieldDerivedState.ts';

/** Ritorna il set di proprietà che differiscono tra old e new */
export function diffStateProps(
  a: IFieldDerivedState | undefined,
  b: IFieldDerivedState,
): Set<FieldDerivedStateKey> {
  const changed = new Set<FieldDerivedStateKey>();
  if (!a) return new Set(DERIVED_STATE_KEYS);
  for (const key of DERIVED_STATE_KEYS) {
    if (a[key] !== b[key]) changed.add(key);
  }
  return changed;
}
